<template>
    <div>
        <!-- DESARROLLLO INICIADO EL MARTES 28 DE JULIO -->


        <!-- boton crear -->
        <v-row v-if="componenteEvento.agregar_submodulo">
            <v-col class="d-flex flex-row-reverse">
                <CommonButtons @click="addItem" iconBut="fas fa-plus" textButton="CREAR CONFIGURACIÓN DE NOTA NUMÉRICA"
                    normalButton />
            </v-col>
            <v-col cols="12">
                <ComundataTablecomp :headers="NotanumericaHeaders" :items="Datos" whitSearch :search="search">
                    <template v-slot>
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <AutocompleteComp @change="getAllConfigNotasNumericas(filtro.ano_lectivo)"
                                    textLabel="Año lectivo" :items="anios_lectivos" autocomplete="off" item-value="id"
                                    item-text="nom_anolectivo" v-model="filtro.ano_lectivo" />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:action_editar="{ item }">
                        <CommonButtons v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
                            tooltipText="Editar nota" />
                    </template>

                    <template v-slot:action_borrar="{ item }">
                        <CommonButtons v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)" deleteButton
                            tooltipText="Eliminar nota" />
                    </template>
                </ComundataTablecomp>
            </v-col>
        </v-row>
        <!-- fin boton  crear-->



        <!-- /////////////////////////////////////////////////////
            //             PANTALLA PRINCIPAL                  //
            /////////////////////////////////////////////////////  -->

        <!-- fin de pantalla principal -->





        <!-- /////////////////////////////////////////////////////
             //     MODAL DE AGREGAR O EDITAR                //
        ////////////////////////////////////////////////////    -->

        <v-form ref="formDatos" lazy-validation>
            <CommonDialog v-model="dialog" maxWidth="650" :title="formTitle" @close-modal="dialog = false">
                <template v-slot:body>
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="dataForm.nota_min" label="Nota mínima" type="number" min="0" max="100"
                                :rules="validationRules.validateCampo" @keypress="soloNumeros($event)"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field v-model="dataForm.nota_max" label="Nota máxima" type="number"
                                :min="dataForm.nota_min" max="100" :rules="validationRules.validateCampo" @key="asignar()"
                                @keypress="soloNumeros($event)"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-checkbox color="#01579b" v-model="dataForm.porcentaje"
                                label="Utilizar porcentaje %"></v-checkbox>
                        </v-col>


                        <v-col cols="12" sm="4">
                            <v-text-field v-model="dataForm.aprob_min" label="Nota mínima aprobatoria" type="number"
                                :rules="validationRules.validateCampo" @keypress="soloNumeros($event)" :min="dataForm.nota_min"
                                :max="dataForm.nota_max"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field v-model="dataForm.nota_max" label="Nota máxima aprobatoria" type="number"
                                readonly></v-text-field>
                        </v-col>


                        <v-col cols="12" sm="12">
                            <v-textarea v-model="dataForm.descripcion" label="Descripción" rows="2"></v-textarea>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-checkbox color="#01579b" v-model="dataForm.decimales"
                                label="Utilizar decimales"></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="4" class="py-0" v-if="dataForm.decimales">
                            <v-text-field v-model="dataForm.cant_decimales" label="Cantidad de decimales"
                                @keypress="validateDecimales($event)"></v-text-field>
                        </v-col>

                    </v-row>

                </template>
                <template v-slot:actions>
                    <v-spacer></v-spacer>
                    <CommonButtons v-if="evento == 'editar'" @click="saveItem(dataForm.id)" textButton="Guardar cambios"
                        iconBut="fas fa-save" normalButton>

                    </CommonButtons>
                    <CommonButtons v-if="evento == 'agregar'" @click="saveItem" textButton='Guardar' iconBut="fas fa-save"
                        normalButton>

                    </CommonButtons>

                </template>
            </CommonDialog>


        </v-form>
        <!-- fin de modal agregar o editar perfil -->





        <!-- /////////////////////////////////////////////////////
        //         MODAL DE ELIMINAR REGISTROS                  //
        /////////////////////////////////////////////////////    -->
        <CommonDialog Deletedialog v-model="dialog_delete" @close-modal="dialog_delete = false"
            titleWindow="Eliminar nota númerica" @delete-item="deleteItem" @cancel-item="dialog_delete = false">
            <template v-slot:body>
                ¿Está seguro de eliminar este registro?
            </template>
        </CommonDialog>

        <!-- fin de modal de eliminar registro -->


    </div>
</template>




<script>
import axios from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import CommonDialog from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import CommonButtons from "../../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import { NotanumericaHeaders } from '../../../../helpers/headersTable';
import { validationRules } from '../../../../helpers/validatorHelpers';



export default {
    name: 'formNotaNum',

    props: ['parametros', 'anios_lectivos'],

    components: {
        CommonDialog,
        CommonButtons,
        ComundataTablecomp,
        AutocompleteComp
    },

    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { 'id_submodulo': 86, "id_modulo": 5 }, //sud_modulo y modulo

        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////
        NotanumericaHeaders,

        filtro: [],
        search: '',
        Datos: [],



        //validaciones de formulario


        // MODAL AGREGRAR-EDITAR NOTA NUMERICA
        evento: null,
        titulo: 'configuración de nota numérica',
        dialog: false,
        formTitle: '',
        dataForm: [],
        ///////////////////////////////



        // MODAL ELIMINAR NOTA NUMERICA
        dialog_delete: false,
        desc_delete: null,
        id_delete: null,
        ///////////////////////////////
    }),


    computed: {
        ...mapGetters('login', ['componenteEvento']),
        validationRules() {
            return validationRules
        },
    },


    mounted() {
        this.loadMain()
    },


    created() {
        this.actualizarParamentro()
    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////




        // funcion para solo permitir numeros
        soloNumeros(event) {
            var key = window.event ? event.which : event.keyCode

            if (key < 48 || key > 57) {
                event.preventDefault()
            }

            if (this.dataForm.nota_min > 100) {
                this.dataForm.nota_min = null
            }

            if (this.dataForm.nota_max > 100) {
                this.dataForm.nota_max = null
            }

            if (this.dataForm.aprob_min > 100) {
                this.dataForm.aprob_min = null
            }
        },



        validateDecimales(event) {
            var key = window.event ? event.which : event.keyCode
            if (key < 48 || key > 57) {
                event.preventDefault()
            }

            if (this.dataForm.cant_decimales.length > 2) {
                this.dataForm.cant_decimales = this.dataForm.cant_decimales.substring(0, this.dataForm.cant_decimales.length - 1)
            }
        },


        asignar(response) {
            this.dataForm.interpretacion = response.descripcion
        },



        //  ------- MOSTRAR TODOS LOS REGISTROS    --------
        async loadMain() {
            let params = {
                "id_colegio": sessionStorage.id_colegio,
                "id_ano_lectivo": sessionStorage.id_ano_lectivo
            }

            try {
                let response = await axios.post("administrativo/confNotaNumerica/getConfiguracionNumerica/", params);
                this.Datos = response.data;
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },


        //////consultar configuracion de nota segun año lectivo/////
        async getAllConfigNotasNumericas(id) {
            let params = {
                "id_colegio": sessionStorage.id_colegio,
                "id_ano_lectivo": id
            }

            try {
                let response = await axios.post("/administrativo/confNotaNumerica/getConfiguracionNumerica/", params);
                this.Datos = response.data;

            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        ////////////////////////////////////////////////////////////



        async limpiarForm() {
            this.dataForm = {
                id_us_ing: this.datoLogin.id, id_colegio: this.datoLogin.id_colegio, id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id: 0, descripcion: '', nota_min: '', nota_max: '', porcentaje: false, decimales: false
            }

            //this.decimales = false
            //this.porcentaje = false
            //this.dataNumber = []

            this.$refs.formDatos.resetValidation()
        },


        //----------- AREGAR REGISTROS  --------------
        async addItem() {
            let validateRegistro = await this.validateRegistroAnoLectivo()

            if (validateRegistro.length === 0) {
                this.limpiarForm()
                this.formTitle = "Crear " + this.titulo
                this.dialog = true
                this.evento = 'agregar'
            }

            else {
                this.setEnviarMens({ tipo: "W", mensaje: 'Ya existe una configuración de nota númerica para el año lectivo actual.', tiempo: null })
            }
        },



        ///*//// consultar si el año lectivo tiene configuracion ///
        async validateRegistroAnoLectivo() {
            let data = []

            try {
                let params = { "id_colegio": sessionStorage.id_colegio, "id_ano_lectivo": sessionStorage.id_ano_lectivo }
                let response = await axios.post("/administrativo/confNotaNumerica/getConfiguracionNumerica/", params)
                data = response.data
            }

            catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
            }

            return data
        },
        /////////////////////////////////////////////





        // Guardar registro
        async saveItem(id) {
            if (this.$refs.formDatos.validate()) {


                if (this.dataForm.decimales === true) {
                    this.dataForm.utiliza_decimales = 1
                }
                else {
                    this.dataForm.utiliza_decimales = 0
                }


                if (this.dataForm.porcentaje === true) {
                    this.dataForm.utiliza_porcertaje = 1
                }
                else {
                    this.dataForm.utiliza_porcertaje = 0
                }

                this.dataForm.aprob_max = this.dataForm.nota_max


                try {
                    if (this.evento == "agregar") {
                        let response = await axios.post("/administrativo/confNotaNumerica/addeNotaNumerica/", this.dataForm)

                        if (response.data.messageT == "S") {
                            this.loadMain()
                            this.dialog = false
                            this.evento = null
                            this.limpiarForm()
                        }

                        this.setEnviarMens({ tipo: response.data.messageT, mensaje: `¡Información agregada con éxito!`, tiempo: null })
                    }

                    else {
                        let response = await axios.put("/administrativo/confNotaNumerica/" + id, this.dataForm)

                        if (response.data.messageT == "S") {
                            this.loadMain()
                            this.dialog = false
                            this.evento = null
                            this.limpiarForm()
                        }

                        this.setEnviarMens({ tipo: response.data.messageT, mensaje: `¡Información editada con éxito!`, tiempo: null })
                    }
                }


                catch (error) {
                    this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                }

            }

            else {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe de ingresar todos los campos requeridos`, tiempo: null })
            }
        },
        ////////////////////////////////////////////////////////



        //--------------EDITAR REGISTRO--------------
        editItem(item) {
            this.limpiarForm()
            this.formTitle = "Editar " + this.titulo
            this.dialog = true
            this.evento = "editar"

            item.id_usuario = this.datoLogin.id
            this.dataForm = Object.assign({}, item)

            this.dataForm.porcentaje ? item.utiliza_porcertaje === 1 : false
            this.dataForm.decimales ? item.utiliza_decimales === 1 : false

        },



        // activa la modal para confirmar el eliminar el registro
        deleteConfirm(items) {
            this.dialog_delete = true
            this.id_delete = items.id
        },



        //------------ELIMINAR Registro -------------
        async deleteItem() {
            try {
                let res = await axios.delete("/administrativo/confNotaNumerica/" + this.id_delete)

                if (res.data.messageT == "S") {
                    this.loadMain()
                    this.dialog_delete = false
                }

                this.setEnviarMens({ tipo: res.data.messageT, mensaje: `¡Información eliminada con éxito!`, tiempo: null })
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },



        /////////////////////////////////////////////////////////
        validateCampos() {
            if (this.dataForm.nota_min > 100 || this.dataForm.nota_max > 100 || this.dataForm.aprob_min > 100) {
                this.validado = false
            } else {
                this.validado = true
            }
        },

    },
}
</script>

